import * as PicabooConstants from '../common/PicabooConstants';
import { isList } from 'immutable';

// because they gave us mm measurements for some reason
const mmToInches = (mm) => mm / 25.4;
const MAX_PAGES = 1000;
const MIN_PAGES = 20;

class SpineHelper {
  static calculateSpineWidthInInches(totalPages, spineSizes) {
    if (spineSizes) {
      if (isList(spineSizes)) {
        spineSizes = spineSizes.toJS();
      }

      for (const spineWidth of spineSizes) {
        if (totalPages <= spineWidth.pages) {
          return spineWidth.size;
        }
      }
      console.error('Failed to get spineWidth');
    }
    return 0;
  }

  static calculateSpineWidth(
    pageWidth,
    totalPages,
    product,
    productStyle,
    productInfo,
  ) {
    let widthInInches = SpineHelper.calculateSpineWidthInInches(
      totalPages,
      productInfo ? productInfo.get('spineSizes') : null,
    );
    let pageWidthInInches = 0;

    let size =
      productInfo && productInfo.has('availableSizes')
        ? productInfo
            .get('availableSizes')
            .toJS()
            .find((e) => e.id === product)
        : 0;
    if (size) {
      pageWidthInInches = size.baseCoverPageWidth / 2.0;
    }

    let totalCoverWidthInInches = pageWidthInInches * 2 + widthInInches;
    let dpi = pageWidth / totalCoverWidthInInches;

    return widthInInches * dpi;
  }

  static calculatorSpineShift(
    pageWidth,
    totalPages,
    product,
    productStyle,
    productInfo,
  ) {
    let min = this.calculateSpineWidth(
      pageWidth,
      0,
      product,
      productStyle,
      productInfo,
    );
    let current = this.calculateSpineWidth(
      pageWidth,
      totalPages,
      product,
      productStyle,
      productInfo,
    );

    return current - min;
  }

  static calculateMaxSpineWidth(pageWidth, product, productStyle, productInfo) {
    return this.calculateSpineWidth(
      pageWidth,
      productInfo ? productInfo.get('maxPages') : MAX_PAGES,
      product,
      productStyle,
      productInfo,
    );
  }

  static calculateMinSpineWidth(pageWidth, product, productStyle, productInfo) {
    return this.calculateSpineWidth(
      pageWidth,
      productInfo ? productInfo.get('minPages') : MIN_PAGES,
      product,
      productStyle,
      productInfo,
    );
  }

  static spineWillChange(oldPageCount, newPageCount, spineSizes) {
    if (spineSizes) {
      if (isList(spineSizes)) {
        spineSizes = spineSizes.toJS();
      }

      return (
        this.calculateSpineWidthInInches(oldPageCount, spineSizes) !==
        this.calculateSpineWidthInInches(newPageCount, spineSizes)
      );
    }
    return false;
  }
}

export default SpineHelper;
